import gql from "graphql-tag";

// fragment
export const TAG_FRAGMENT = gql`
    fragment tag on TagNode {
        id
        tag
        orderId
        updatedAt
        updatedBy
    }
`;

// all query
export const TAGS_QUERY = gql`
    query {
        tenantTags {
            edges {
                node {
                    ...tag
                }
            }
        }
    }
    ${TAG_FRAGMENT}
`;

// single query
export const SINGLE_TAG_QUERY = gql`
    query tag($id: ID!) {
        tag(id: $id) {
            ...tag
        }
    }
    ${TAG_FRAGMENT}
`;

// create
export const CREATE_TAG_MUTATION = gql`
    mutation createTag($input: CreateTagInput!) {
        createTag(input: $input) {
            tag {
                ...tag
            }
        }
    }
    ${TAG_FRAGMENT}
`;

// update
export const UPDATE_TAG_MUTATION = gql`
    mutation updateTag($input: UpdateTagInput!) {
        updateTag(input: $input) {
            tag {
                ...tag
            }
        }
    }
    ${TAG_FRAGMENT}
`;

// delete
export const DELETE_TAG_MUTATION = gql`
    mutation deleteTag($input: DeleteTagInput!) {
        deleteTag(input: $input) {
            tag {
                ...tag
            }
        }
    }
    ${TAG_FRAGMENT}
`;
